export const BGM_VOLUME = 0.2
export const TOAST_SCALE = 0.15
export const SPEED_EFFECT_TIME = 7200
export const DEFAULT_TOSS_SPEED = 1100
export const TIME_TO_ENTER_SPEED_EFFECT = 900